export default () => ({
  cardDetailsWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  brandIconWrapper: {
    marginRight: 10,
    width: 67,
    height: 47,
    display: 'inline-block',
    '& svg': {
      width: '100%',
      height: '100%',
    },
  },
  defaultCard: {
    marginLeft: 5,
    fontWeight: 'bold',
    fontSize: 14,
  },
});
